import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import {Field} from "@intelingu/core/components/form/Field";
import {TextInput} from "../../../partials/form/elements/TextInput";
import {SubmitButton} from "../../../partials/form/elements/SubmitButton";
import {Form} from "@intelingu/core/components/form/Form";
import {action, observable} from "mobx";
import Logger from "@intelingu/core/utils/Logger";
import {IsDefined} from "class-validator";
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import withTranslation from "@intelingu/core/utils/withTranslation";
import {COMMON_NS} from "@intelingu/core/constants/base.constants";
import {lazyInject} from "@intelingu/core/IoC/container";
import {UserStore} from "@intelingu/core/stores/UserStore";
import {AuthStore} from "../../../../stores/AuthStore";

interface LoginFormComponentProps {
    t?;
}

class LoginRequest {

    email: string;

    @IsDefined()
    password: string;

}

@withTranslation(COMMON_NS)
@observer export class LoginFormComponent extends Component<LoginFormComponentProps, any> {

    @lazyInject(UserStore) userStore: UserStore;
    @lazyInject(AuthStore) authStore: AuthStore;

    @observable isError = false;

    @action.bound async login(data: LoginRequest, done) {
        const { email, password } = data;

        try {
            await this.authStore.authorize(email, password);
        } catch (e) {
            this.isError = true;

            Logger.error(e);
        } finally {
            done();
        }
    }

    render() {
        const { t } = this.props;

        return <Form validator={LoginRequest} onSubmit={this.login}>
            <FormGroup>
                <Label for="email">{ t('sessionEmail') }</Label>

                <Field
                    name={'email'}
                    render={props => <TextInput {...props} />}
                />
            </FormGroup>

            <FormGroup>
                <Label for="password">{ t('sessionPassword') }</Label>

                <Field
                    name={'password'}
                    render={props => <TextInput type={'password'} {...props} />}
                />
            </FormGroup>

            { this.isError && (
                <div className="alert alert-danger" style={{ display: 'block' }}>{ t('sessionLoginOrPasswordError') }</div>
            )}

            <FormGroup check>
                <Label check>
                    <Field name={'remember'} render={({ onChange }) =>
                        <Input type="checkbox" onChange={e => onChange(e.target.checked)} />
                    }/>{' '}
                    { t('sessionRememberMe') }
                </Label>
            </FormGroup>

            <FormGroup style={{ marginTop: 20 }}>
                <Field submit render={props => <SubmitButton className={'outline'} {...props}>{ t('sessionLogInButton') }</SubmitButton>} />
            </FormGroup>
        </Form>
    }

}
